<div class="modern-auth-wrappers">
    <div class="auth-containers">
        <form [formGroup]="form">
            <div *ngIf="!isReset">
                <div class="icon-lock">
                    <svg width="48" height="60" viewBox="0 0 57 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M46.0417 24.7917V17.7083C46.0417 7.79167 38.25 0 28.3333 0C18.4167 0 10.625 7.79167 10.625 17.7083V24.7917C4.60417 24.7917 0 29.3958 0 35.4167V60.2083C0 66.2292 4.60417 70.8333 10.625 70.8333H46.0417C52.0625 70.8333 56.6667 66.2292 56.6667 60.2083V35.4167C56.6667 29.3958 52.0625 24.7917 46.0417 24.7917ZM17.7083 17.7083C17.7083 11.6875 22.3125 7.08333 28.3333 7.08333C34.3542 7.08333 38.9583 11.6875 38.9583 17.7083V24.7917H17.7083V17.7083ZM32.2292 47.8125L31.875 48.1667V53.125C31.875 55.25 30.4583 56.6667 28.3333 56.6667C26.2083 56.6667 24.7917 55.25 24.7917 53.125V48.1667C22.6667 46.0417 22.3125 42.8542 24.4375 40.7292C26.5625 38.6042 29.75 38.25 31.875 40.375C34 42.1458 34.3542 45.6875 32.2292 47.8125Z"
                            fill="black" />
                    </svg>
                </div>
                <div class="reset-title-block">
                    <h2 class="reset-title">Reset your password</h2>
                    <p class="reset-subtitle">Forgot your password? Please enter your email and we'll send you a secure
                        reset link.</p>
                </div>
                <div class="reset-input-block">
                    <div class="reset-field-group">
                        <label class="reset-field-label">Enter your email</label>
                        <input type="email" class="reset-field-input" placeholder="johndoe@gmail.com"
                            formControlName="userName">
                        <div *ngIf="getFormControls.userName.touched && getFormControls.userName.errors?.['required']"
                            class="reset-error-msg">Email is required</div>
                    </div>
                    <button class="reset-gradient-btn" [disabled]="!form.valid || !showBtn" (click)="reset()">
                        <span *ngIf="showBtn">Submit</span>
                        <span *ngIf="!showBtn" class="reset-spinner"></span>
                    </button>
                    <div class="reset-or-divider">OR</div>
                    <button type="button" class="reset-back-btn" (click)="location.back()">&#8592; Go Back</button>
                </div>
            </div>
            <div *ngIf="isReset" class="reset-title-blocks">
                <div class="icon-lock">
                    <svg width="48" height="60" viewBox="0 0 57 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M46.0417 24.7917V17.7083C46.0417 7.79167 38.25 0 28.3333 0C18.4167 0 10.625 7.79167 10.625 17.7083V24.7917C4.60417 24.7917 0 29.3958 0 35.4167V60.2083C0 66.2292 4.60417 70.8333 10.625 70.8333H46.0417C52.0625 70.8333 56.6667 66.2292 56.6667 60.2083V35.4167C56.6667 29.3958 52.0625 24.7917 46.0417 24.7917ZM17.7083 17.7083C17.7083 11.6875 22.3125 7.08333 28.3333 7.08333C34.3542 7.08333 38.9583 11.6875 38.9583 17.7083V24.7917H17.7083V17.7083ZM32.2292 47.8125L31.875 48.1667V53.125C31.875 55.25 30.4583 56.6667 28.3333 56.6667C26.2083 56.6667 24.7917 55.25 24.7917 53.125V48.1667C22.6667 46.0417 22.3125 42.8542 24.4375 40.7292C26.5625 38.6042 29.75 38.25 31.875 40.375C34 42.1458 34.3542 45.6875 32.2292 47.8125Z"
                            fill="black" />
                    </svg>
                </div>
                <div class="reset-title-block">
                    <h2 class="reset-title">Check your email</h2>
                    <p class="reset-subtitle">Reset link has been successfully sent to your registered email address.
                    </p>
                </div>
            </div>
        </form>
    </div>
</div>